import styled from "styled-components";
import {BackTableField} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React, {useState} from "react";
import {headerTypesIcons, schemas} from "../../../config";
import {Field, FIELD_TYPE_INFO} from "../../../Types";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {faCheck, faEdit, faQuestion, faTriangleExclamation, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSelector} from "react-redux";
import EditJoin from "./edit/EditJoin";
import EditField from "./edit/EditField";

interface BackTableFieldPropsI {
    tableName: string,
    tableKey: string,
    field: BackTableField,
    index: number,
    joins: Record<string, string>
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FieldItemViewPropsI = {
    field: BackTableField,
    tableKey: string,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
    fieldSchema?: Field,
    joins: Record<string, string>
};

export default function BackTableFieldViewTable({tableName, fields, joins}: {
    tableName: string,
    fields: Record<string, BackTableField>,
    joins: Record<string, string>
}) {

    return <Container>
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Ключ</th>
                <th>Фронт тип</th>
                <th>На фронті</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(fields).map(([key, field], i) =>
                <BackTableFieldView key={key} index={i} tableName={tableName} tableKey={key} field={field}
                                    joins={joins}/>)}
            </tbody>
        </table>

    </Container>
}

function BackTableFieldView({
                                tableName,
                                tableKey,
                                field,
                                index,
                                joins
                            }: BackTableFieldPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticField = staticTable !== null && staticTable.fieldsList[tableKey]
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealField = etherealTable !== null && etherealTable.fieldsList[tableKey]
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const project = useAppSelector(state => state.project.name);

    const fields: Field[] | undefined = schemas[project].tables[tableName]?.fields;
    const dispatch = useAppDispatch();

    let fieldSchema = fields && fields.find((v) => v.key === tableKey)

    return <>
        {mode === "edit" && staticField &&
            <FieldItemView joins={staticTable.joins} fieldSchema={fieldSchema} type={"static"} field={staticField}
                           tableKey={tableKey}
                           index={index}/>}
        {mode === "edit" && etherealField &&
            <FieldItemView joins={joins} fieldSchema={fieldSchema} type={"ethereal"} editable
                           field={etherealField}
                           tableKey={tableKey} index={index}/>}
        {mode === "view" &&
            <FieldItemView joins={joins} fieldSchema={fieldSchema} type={"other"} field={field}
                           tableKey={tableKey} index={index}/>}
    </>
}

export const SqlQuery = ({sqlQuery}: { sqlQuery: string }) => {
    return <pre style={{overflowX: "auto"}}><code
        style={{overflow: 'auto', width: "100%", maxWidth: '100%'}}
        dangerouslySetInnerHTML={{__html: hljs.highlight(sqlQuery, {language: 'sql'}).value}}
        className={'language-sql hljs'}></code></pre>
}

function FieldItemView({
                           field,
                           index,
                           tableKey,
                           type,
                           editable = false,
                           fieldSchema,
                           joins
                       }: FieldItemViewPropsI) {
    // <FieldItemStyled $hasSql={!!sqlQuery} $type={type}>

    const [isEditing, setIsEditing] = useState(false)
    const closeEditing = () => setIsEditing(false);

    return <>
        <tr className={"title"}>
            <td className="icon">
                {fieldSchema && <FontAwesomeTypeIcon className={'fa-color-text'} type={fieldSchema.type}/>}
                {!fieldSchema && <FontAwesomeIcon className={'fa-color-text'} icon={faQuestion}/>}
            </td>
            <td className={'key'}>
                <div className="cont">
                    <span>{tableKey}</span>
                    {editable && <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
                    </button>}
                </div>
                {isEditing &&
                    <EditField closeEditing={closeEditing} field={field} fieldKey={tableKey}/>}
            </td>
            <td className="content">
                {/*<div >*/}
                {fieldSchema && <span style={{
                    background: FIELD_TYPE_INFO[fieldSchema.type].color,
                    color: getReadableTextColor(FIELD_TYPE_INFO[fieldSchema.type].color)
                }} className={"front-type"}>{headerTypesIcons[fieldSchema.type].alt}</span>}

                {/*</div>*/}
            </td>
            <td className="present">
                <span className="missing"><FontAwesomeIcon size={"lg"}
                                                           className={fieldSchema ? 'fa-color' : 'fa-yellow'}
                                                           icon={fieldSchema ? faCheck : faXmark}/>
                </span>
            </td>
            {/*{!fieldSchema && <td className="missing">Відсутній на фронті</td>}*/}
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
        {field.sqlQuery &&
            <tr className={'row'}>
                <td className={'sql'} colSpan={7}>
                    <div className="sql-cont">
                        <SqlQuery sqlQuery={field.sqlQuery}/>
                    </div>
                </td>
            </tr>
        }
        {Array.isArray(field.joinDependencies) && field.joinDependencies.length > 0 &&
            <>
                <tr>
                    <td colSpan={2}></td>
                    <td className={'join-dep'} colSpan={10}>Залежить від джоїнів</td>
                </tr>
                {field.joinDependencies.map((j, i) => <tr key={i}>
                    <td className={'join-key'} colSpan={2}>{j}</td>
                    <td colSpan={8} className={'sql'}>{joins[j] ?
                        <div className="sql-cont"><SqlQuery sqlQuery={joins[j]}/></div>
                        : <div className={'not-found-join'}>
                            <FontAwesomeIcon size={"lg"}
                                             className={'fa-yellow'}
                                             icon={faTriangleExclamation}/>
                            ТАКОГО ДЖОЇНА НЕ ЗНАЙДЕНО
                            <FontAwesomeIcon size={"lg"}
                                             className={'fa-yellow'}
                                             icon={faTriangleExclamation}/>
                        </div>}
                    </td>
                </tr>)}
            </>

        }
    </>
}


const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;

    .add-new {
        display: inline-flex;
        gap: .5rem;
        align-items: center;
        justify-content: space-between;

        & button {
            padding: 0;
            appearance: none;
            border: none;
            background: none;
        }
    }

    .join-key {
        text-align: right;
        padding-right: .6rem;
        font-weight: bold;
    }

    .join-dep {
        padding-left: .4rem;
    }

    .not-found-join {
        text-align: center;
    }

    table {
        table-layout: auto;
        //max-width: 100%;
        width: 100%;
        //overflow-x: auto;
        border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border-bottom: 2px solid var(--table-border-color);
            border-right: 2px solid var(--table-border-color);
            border-left: 2px solid var(--table-border-color);
            border-top: 2px solid var(--table-border-color);

        }


        //tr:not(last-child) {
        //    td {
        //        border-bottom: 2px solid red;
        //
        //    }
        //}

        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {

        max-width: 100%;
        //overflow-x: scroll;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

        td {

            //overflow-x: auto;

        }


    }

    .present {
        text-align: center;
    }

    .content {
        width: 100%;
    }

    .title {

        line-height: 1;

        .icon {
            //width: 1.25rem;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            width: 1%;
            text-align: center;
        }

        .key {
            width: 1%;
            text-align: left;
            padding-right: .4rem;
            padding-left: .4rem;

            .cont {
                display: inline-flex;
                gap: .5rem;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                & button {
                    padding: .2rem;
                }
            }
        }

        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

        .missing {
            //background-color: #62615c;
            //color: yellow;
            //padding: .2rem .4rem;
            //border-radius: .2rem;
        }
    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

    .row {
        overflow-x: auto;
    }

    .sql {
        //display: block;
        overflow-x: auto;
        max-width: 1px;

        white-space: nowrap;

        .sql-cont {
            max-width: 100%;
            //max-width: 500px;

            word-break: break-word;
            overflow-x: auto;
        }
    }


`;
